
import { useEffect } from 'react';
import { useRouter } from '@/lib/navigation';
import { isAdminAuthenticated } from '@/lib/admin-auth';

type AdminRootRedirectProps = {
  fallbackLogin: string;
  fallbackDashboard: string;
};

export default function AdminRootRedirect({
  fallbackLogin,
  fallbackDashboard,
}: AdminRootRedirectProps) {
  const router = useRouter();

  useEffect(() => {
    router.replace(isAdminAuthenticated() ? fallbackDashboard : fallbackLogin);
  }, [router, fallbackLogin, fallbackDashboard]);

  return null;
}
